import { ProductFeatureIconName } from '@oy/uiicon';

export const productIconName: Record<string, ProductFeatureIconName> = {
  ACCOUNT_STATEMENT: 'transaction-report',
  SETTLEMENT_REPORT: 'disbursement/api-disburse',
  API_DISBURSE: 'disbursement/api-disburse',
  BULK_DISBURSEMENT: 'disbursement/bulk',
  CLAIM_FUND: 'disbursement/claim-fund',
  INTERNATIONAL_TRANSFER: 'disbursement/international-remittance',
  PAYMENT_LINK_ONE_TIME: 'request-money/payment-checkout',
  PAYMENT_LINK_REUSABLE: 'request-money/payment-checkout',
  PAYMENT_LINK_REUSABLE_CHILD: 'request-money/payment-checkout',
  VA_CREATED: 'virtual-account',
  VA_INCOMING_PAYMENT: 'virtual-account',
  E_WALLET: 'request-money/e-wallet',
  PAYMENT_ROUTING: 'request-money/payment-routing',
  QRIS_STATIC: 'qris',
};

export const productName: Record<string, string> = {
  SETTLEMENT_REPORT: 'pageTitle_settlementReport',
  PAYMENT_LINK_ONE_TIME: 'autoReport_acceptance_paymentLink_oneTime',
  PAYMENT_LINK_REUSABLE:
    'autoReport_acceptance_paymentLink_reusable_createdReusableLink',
  PAYMENT_LINK_REUSABLE_CHILD:
    'autoReport_acceptance_paymentLink_reusable_allTxnList',
  VA_CREATED: 'autoReport_acceptance_va_createdVA',
  VA_INCOMING_PAYMENT: 'autoReport_acceptance_va_incomingPayment',
  E_WALLET: 'common_eWallet',
  PAYMENT_ROUTING: 'common_paymentRouting',
  QRIS_STATIC: 'qris_static',
};
